import { useState } from "react";
import { Trash2, ChevronUp, ChevronDown, Plus } from "lucide-react";

export const Field = ({ label, value, onChange, textarea, placeholder, testid }) => (
  <label className="block mb-3">
    {label && <span className="block text-xs mb-1 uppercase tracking-wider" style={{ color: "var(--text-sec)" }}>{label}</span>}
    {textarea ? (
      <textarea className="a-textarea" value={value ?? ""} placeholder={placeholder} onChange={(e) => onChange(e.target.value)} data-testid={testid} />
    ) : (
      <input className="a-input" value={value ?? ""} placeholder={placeholder} onChange={(e) => onChange(e.target.value)} data-testid={testid} />
    )}
  </label>
);

export const Card = ({ title, children }) => (
  <details className="glass mb-4" open style={{ padding: "1.1rem 1.3rem" }}>
    <summary className="font-head font-bold cursor-pointer text-lg mb-2 select-none">{title}</summary>
    <div className="mt-4">{children}</div>
  </details>
);

// Generic list-of-objects editor
export function ObjectListEditor({ items = [], onChange, fields, addTemplate, labelPrefix }) {
  const update = (i, key, val) => {
    const next = items.map((it, idx) => (idx === i ? { ...it, [key]: val } : it));
    onChange(next);
  };
  const remove = (i) => onChange(items.filter((_, idx) => idx !== i));
  const move = (i, dir) => {
    const j = i + dir;
    if (j < 0 || j >= items.length) return;
    const next = [...items];
    [next[i], next[j]] = [next[j], next[i]];
    onChange(next);
  };
  const add = () => onChange([...items, { ...addTemplate }]);

  return (
    <div>
      {items.map((it, i) => (
        <div key={i} className="mb-4 pb-4" style={{ borderBottom: "1px solid var(--glass-border)" }}>
          <div className="flex items-center justify-between mb-2">
            <span className="text-xs font-bold" style={{ color: "var(--text-sec)" }}>{labelPrefix} {i + 1}</span>
            <div className="flex gap-1">
              <button className="btn-ghost p-1.5 rounded-lg" onClick={() => move(i, -1)} title="Вверх"><ChevronUp size={15} /></button>
              <button className="btn-ghost p-1.5 rounded-lg" onClick={() => move(i, 1)} title="Вниз"><ChevronDown size={15} /></button>
              <button className="btn-ghost p-1.5 rounded-lg" onClick={() => remove(i)} title="Удалить"><Trash2 size={15} /></button>
            </div>
          </div>
          {fields.map((f) => (
            <Field key={f.key} label={f.label} value={it[f.key]} textarea={f.textarea} onChange={(v) => update(i, f.key, v)} />
          ))}
        </div>
      ))}
      <button className="btn-ghost px-4 py-2 text-sm flex items-center gap-1" onClick={add}><Plus size={15} /> Добавить</button>
    </div>
  );
}

// List of strings editor (quiz options)
export function StringListEditor({ items = [], onChange }) {
  const update = (i, val) => onChange(items.map((it, idx) => (idx === i ? val : it)));
  const remove = (i) => onChange(items.filter((_, idx) => idx !== i));
  const move = (i, dir) => {
    const j = i + dir;
    if (j < 0 || j >= items.length) return;
    const next = [...items];
    [next[i], next[j]] = [next[j], next[i]];
    onChange(next);
  };
  return (
    <div>
      {items.map((it, i) => (
        <div key={i} className="flex items-center gap-2 mb-2">
          <input className="a-input flex-1" value={it} onChange={(e) => update(i, e.target.value)} />
          <button className="btn-ghost p-2 rounded-lg" onClick={() => move(i, -1)}><ChevronUp size={14} /></button>
          <button className="btn-ghost p-2 rounded-lg" onClick={() => move(i, 1)}><ChevronDown size={14} /></button>
          <button className="btn-ghost p-2 rounded-lg" onClick={() => remove(i)}><Trash2 size={14} /></button>
        </div>
      ))}
      <button className="btn-ghost px-4 py-2 text-sm flex items-center gap-1" onClick={() => onChange([...items, "Новый вариант"])}><Plus size={14} /> Добавить вариант</button>
    </div>
  );
}
